import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, TextField, Typography, Select, MenuItem, SelectChangeEvent,useTheme, } from '@mui/material'; // Import Select and MenuItem
import axios from 'axios';

import { Directory } from './directory';
import { Link, useNavigate } from 'react-router-dom';
// import { setSelectedLogsuman } from '../../store/dailylog/dailyLogsSlice';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../../theme/theme';

import { DirectoryFields } from '../../../constants/directoryfields';
import { AUTOFILL_STYLES, BASEURL } from '../../../constants/Common';

const DirectoryAddUser: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
//   const [newLog, setNewLog] = useState<UserRole>({
//     id: null,
//     rolename: '',
//     status: 'Active',
//     note:'',
//     projectaccess: 'No Access',
//     scheduleaccess: 'No Access',
//     modulesaccess: 'No Access',
//     // createdon: '',
//     reportsaccess: 'No Access',
//   });

const [newLog, setNewLog] = useState<Directory>({
    id: null,
    user_id: '',
    username:'',
    organization: '', 
    email: '',
    password: '', 
    createdon: 'new Date().toISOString()', // Convert Date to string with ISO format
    category: '', 
    role:'',
    title:'',
    
   
  });

  const formatDate = (dateString: string | Date | null): string => {
    if (!dateString) {
      return ''; // Return an empty string if dateString is null or undefined
    }
  
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = ('0' + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 to month index since it's zero-based
    const day = ('0' + dateObject.getDate()).slice(-2);
  
    return `${year}-${month}-${day}`;
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent<string>
  ) => {
    const { name, value } = event.target as HTMLInputElement | HTMLTextAreaElement;
    setNewLog({ ...newLog, [name]: value });
  };

  const validateInputs = () => {
    let valid = true;
    const newErrors: { [key: string]: string } = {};
  
    DirectoryFields.forEach((field) => {
      if (field.isRequired && !newLog[field.name]) { // Use isRequired instead of required
        newErrors[field.name] = `${field.title} is required.`;
        valid = false;
      }
    });
  
    setErrors(newErrors);
    return valid;
  };
  


  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!validateInputs()) {
      return;
    }
    try {
      // Convert newLog to JSON string
      const jsonData = JSON.stringify(newLog);
      console.log("jsonData:", jsonData);
      // Send POST request to create a new user role
      const response = await axios.post(
        BASEURL + '/create-user/',
        jsonData, // Send JSON data
        {
          headers: {
            'Content-Type': 'application/json', // Set content type to JSON
          },
        }
      );
  
      // console.log('response.data:', response.data);
      // dispatch(setSelectedLogsuman(response.data));
      toast.success('New user created successfully');
      // Redirect to the View Role page with the newly created user role ID as a query parameter
      navigate(`/directory`); // Assuming the response contains the ID of the created user role
     
    } catch (error) {
        console.error('Error creating new user:', error);
      
      toast.error('Failed to create new user');
    }
  };

  useEffect(() => {
    // Fetch the current date from the backend and update newLog's createdon
    const fetchCurrentDate = async () => {
      try {
        const response = await axios.get( BASEURL + '/get-current-date/');
        const currentDate = response.data.current_date;
        setNewLog((prevLog) => ({ ...prevLog, createdon: currentDate }));
      } catch (error) {
        console.error('Error fetching current date:', error);
      }
    };

    fetchCurrentDate(); // Call the function on component mount
  }, []); // Empty dependency array to run once on mount
  

  const handleCancelClick = () => {
    navigate('/directory');
  };

  const arrow = '>';

  // Add this function outside your component
  

  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ mt: '-80px' }}>
        <Typography variant='h6' gutterBottom>
          <Link to={'/directory'}>Directory</Link>
          {arrow} Add User
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {DirectoryFields.map((field) => (
              !['projectcode'].includes(field.name) && (
                <Grid item xs={12} key={field.name} sx={{ mb: '10px' }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={4}>
                      <Typography>{field.title}</Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Box sx={{ maxWidth: '350px' }}>
                        {field.type === 'dropDown' ? (
                          <Select
                            fullWidth
                            variant='outlined'
                            name={field.name}
                            value={newLog[field.name] !== null ? newLog[field.name] as string : ''}
                    onChange={handleInputChange}
                          >
                            {field.options?.map((option) => (
                              <MenuItem key={option} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : field.name === 'note' ? (
                          <TextField
                            name={field.name}
                            value={newLog[field.name]}
                            onChange={handleInputChange}
                            fullWidth
                            margin='normal'
                            variant='outlined'
                            multiline
                            rows={3}
                            error={!!errors[field.name]}
                            helperText={errors[field.name]}
                          />
                        ) : field.name === 'attachments' ? (
                          <input type='file' />
                        ) :  field.name === 'createdon' ? ( // Add this condition for createdon field
                        <TextField
                          name={field.name}
                          // type='date' // Assuming type is date for createdon
                          // value={newLog.createdon}
                          type='text' // Change type to text for custom formatting
            value={formatDate(newLog.createdon)} // Format the date using formatDate function
                          onChange={handleInputChange}
                          fullWidth
                          margin='normal'
                          variant='outlined'
                          InputProps={{ readOnly: true }} // Set readOnly to make it non-editable
                          error={!!errors[field.name]}
                          helperText={errors[field.name]}
                        />
                      ) : (

                          <TextField
                            name={field.name}
                            type={
                              field.type === 'date'
                                ? 'date'
                                : field.type === 'dropzone'
                                ? 'dropzone'
                                : 'text'
                            }
                            value={newLog[field.name]}
                            onChange={handleInputChange}
                            fullWidth
                            margin='normal'
                            variant='outlined'
                            error={!!errors[field.name]}
                            helperText={errors[field.name]}
                            sx={{
                              ...AUTOFILL_STYLES(theme),
                            }}
                          />
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              )
            ))}
          </Grid>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: '20px' }}>
            
            <Button type='submit' variant='contained' color='primary' sx={{ marginRight: '10px' }}>
              Save
            </Button>
            <Button
              variant='contained'
              onClick={handleCancelClick}
              
            >
              Cancel
            </Button>
          </Box>
        </form>
      </Box>
    </ThemeProvider>
  );
};

export default DirectoryAddUser;

